import { isArdoqError } from '@ardoq/common-helpers';
import { alert } from '../dialogs/alert';

export const handleOnConfirmAsync = <T>({
  onConfirmAsync,
  resolve,
  errorAlertTitle = 'Error occurred',
  errorAlertSubtitle = "The action couldn't be completed",
}: {
  onConfirmAsync?: (result: T) => void;
  resolve: (result: T | false) => void;
  errorAlertTitle?: string;
  errorAlertSubtitle?: string;
}) => {
  return async (result: T) => {
    try {
      const response = await onConfirmAsync?.(result);
      if (isArdoqError(response)) {
        resolve(false);
        alert({
          title: errorAlertTitle,
          subtitle: errorAlertSubtitle,
        });
        return;
      }
      resolve(result);
    } catch (error) {
      resolve(false);
      alert({
        title: errorAlertTitle,
        subtitle: errorAlertSubtitle,
      });
    }
  };
};
